import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
 

class FindFrameGap_list extends Component {
  constructor(props) {
    super(props);

    this.state = {
      DialogHeight: 300,
    };
  }
  async componentDidMount() {
    let height = window.innerHeight - 600;
    await this.setState({ DialogHeight: height });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
    }
  }

  render() {
    const { tableColNameMapping, tableColMapping } = this.props.transOperation;
    const { findFrameGapErrorData } = this.props.findOperation;
    const { findFrameSplitValue } = this.props.context;
    const { fFrameSplit } = this.props.context;

    let mainContent;

    let listView;
    let findAllTargetDataCount = 0;
    if (findFrameGapErrorData !== null) {
      listView = findFrameGapErrorData.map((obj, index) => {
        const { nextIndex, outTime, type, rowIndex } = obj;

        return (
          <li className="findAllObj">
            <a
              onClick={() => {
                this.props.setFindAllSelectRowCol(
                  rowIndex,
                  tableColMapping[`${type}`]
                );
              }}
            >
              Line {rowIndex + 1}, {nextIndex + 1} : {outTime}
            </a>
            {/* type:"Out",
                    rowIndex:index,
                    nextIndex:index+1,
                    outTime:frameString */}
          </li>
        );
      });

      findAllTargetDataCount = findFrameGapErrorData.length;
    }

    mainContent = (
      <div
        className="small"
        style={{
          overflow: "scroll",
          backgroundColor: "#eed3d7",
          height: `${this.state.DialogHeight}px`,
        }}
      >
        <b>
          <h2 style={{ color: "#b94a48", fontSize: "18pt" }}>
            Find Frame Gap Error Total: {findAllTargetDataCount}
          </h2>
        </b>
        <ul>{listView}</ul>
      </div>
    );

    return (
      <div
        className="findAllView"
        style={{ backgroundColor: "#eed3d7", color: "#3a87ad" }}
      >
        <div
          className="findAllView_close"
          onClick={() => {
            this.props.closefindAllView();
          }}
        >
          x
        </div>

        {mainContent}
      </div>
    );
  }
}

FindFrameGap_list.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
});

export default connect(mapStateToProps, {})(withRouter(FindFrameGap_list));



// WEBPACK FOOTER //
// ./src/components/translations/objects/FindFrameGap_list.js